// config for link-shopper
export const assets = "https://trn-shopper-pmf-static.link-nonprod.wawanesalife.com";
export const gateway = "https://trn-shopper-pmf-gw.link-nonprod.wawanesalife.com";
export const brokerConfig = {
  "authorized_mb": "yes", "authorized_sk": "yes", "authorized_qc": "no", "authorized_nb": "yes", "authorized_ns": "yes","enabled": "yes", "authorized_on": "yes", "authorized_ab": "yes", "authorized_bc": "yes", "split": 0.5,
  "name": "Portage and Main Financials",
  "broker": "pmf",
  "display": "Portage and Main Financials",
  "topic": ""
};
export const brokerBranding = {
  "trn-shopper-pmf-ui.link-nonprod.wawanesalife.com": {
    "a": {
      "website": "https://westernfinancialgroup.ca/",
      "broker": "pmf",
      "accessibilityLink": "https://westernfinancialgroup.ca/Accessibility-Guidelines",
      "themeSwitcher": "show",
      "ftcLink": "https://westernfinancialgroup.ca/Customers-Fair-Treatment",
      "privacyLink": "https://westernfinancialgroup.ca/Privacy",
      "logo": "a.png",
      "email": "bob1965@shawcable.ca",
      "approve_company": "Link Platform",
      "g4": "G-2QM64W4BM4",
      "approve_user": "link_pmf",
      "introduction": "SF1CFpZI1tY",
      "phone": "(204) 555-4321",
      "brand": "trn-shopper-pmf-ui.link-nonprod.wawanesalife.com",
      "ab": "a",
    },
    "b": {
      "website": "https://westernfinancialgroup.ca/",
      "broker": "pmf",
      "accessibilityLink": "https://westernfinancialgroup.ca/Accessibility-Guidelines",
      "themeSwitcher": "show",
      "ftcLink": "https://westernfinancialgroup.ca/Customers-Fair-Treatment",
      "privacyLink": "https://westernfinancialgroup.ca/Privacy",
      "logo": "b.png",
      "email": "bob1965@shawcable.ca",
      "approve_company": "Link Platform",
      "g4": "G-2QM64W4BM4",
      "approve_user": "link_pmf",
      "introduction": "SF1CFpZI1tY",
      "phone": "(204) 555-4321",
      "brand": "trn-shopper-pmf-ui.link-nonprod.wawanesalife.com",
      "ab": "b",
    },
  },
  "trn-pmf-app.link-nonprod.wawanesalife.com": {
    "a": {
      "website": "https://westernfinancialgroup.ca/",
      "broker": "pmf",
      "accessibilityLink": "https://westernfinancialgroup.ca/Accessibility-Guidelines",
      "themeSwitcher": "show",
      "ftcLink": "https://westernfinancialgroup.ca/Customers-Fair-Treatment",
      "privacyLink": "https://westernfinancialgroup.ca/Privacy",
      "logo": "a.png",
      "email": "bob1965@shawcable.ca",
      "approve_company": "Link Platform",
      "g4": "G-2QM64W4BM4",
      "approve_user": "link_pmf",
      "introduction": "SF1CFpZI1tY",
      "phone": "(204) 555-4321",
      "brand": "trn-pmf-app.link-nonprod.wawanesalife.com",
      "ab": "a",
    },
    "b": {
      "website": "https://westernfinancialgroup.ca/",
      "broker": "pmf",
      "accessibilityLink": "https://westernfinancialgroup.ca/Accessibility-Guidelines",
      "themeSwitcher": "show",
      "ftcLink": "https://westernfinancialgroup.ca/Customers-Fair-Treatment",
      "privacyLink": "https://westernfinancialgroup.ca/Privacy",
      "logo": "b.png",
      "email": "bob1965@shawcable.ca",
      "approve_company": "Link Platform",
      "g4": "G-2QM64W4BM4",
      "approve_user": "link_pmf",
      "introduction": "SF1CFpZI1tY",
      "phone": "(204) 555-4321",
      "brand": "trn-pmf-app.link-nonprod.wawanesalife.com",
      "ab": "b",
    },
  },
};
